import { useEffect, useState } from 'react';

const useIntersectionObserver = (
  ref,
  { root = null, rootMargin = '0px', threshold = 0.0, ...config } = {}
) => {
  const [entry, setEntry] = useState({});

  const updateEntry = ([entry]) => setEntry(entry);

  useEffect(() => {
    const observerOptions = {
      root,
      rootMargin,
      threshold,
      ...config,
    };

    const observer = new IntersectionObserver(updateEntry, observerOptions);

    if (ref) {
      observer.observe(ref);
    }

    return () => {
      observer.disconnect();
    };
  }, [ref]);

  return entry;
};

export default useIntersectionObserver;
